// Generic Show More functionality for tables
// 遅延turbo frame内のボタンにも効くよう、documentへのイベントデリゲーションで処理する
class ShowMoreHandler {
  constructor() {
    this.init()
  }

  init() {
    document.addEventListener('click', (e) => {
      const showMoreBtn = e.target.closest('[data-show-more]')
      if (showMoreBtn) {
        e.preventDefault()
        const targetClass = showMoreBtn.getAttribute('data-show-more')
        const tableId = showMoreBtn.getAttribute('data-table-id')
        this.showMore(targetClass, tableId, showMoreBtn)
        return
      }

      const showLessBtn = e.target.closest('[data-show-less]')
      if (showLessBtn) {
        e.preventDefault()
        const targetClass = showLessBtn.getAttribute('data-show-less')
        const tableId = showLessBtn.getAttribute('data-table-id')
        this.showLess(targetClass, tableId, showLessBtn)
      }
    })
  }

  showMore(targetClass, tableId, clickedButton) {
    // 隠されている行を表示
    const hiddenRows = document.querySelectorAll(`.${targetClass}`)
    hiddenRows.forEach(row => {
      row.classList.remove('hidden')
    })

    // ボタンの表示切り替え
    const container = clickedButton.closest('.card-body, .table-container')
    if (container) {
      const showMoreBtn = container.querySelector('[data-show-more]')
      const showLessBtn = container.querySelector('[data-show-less]')

      if (showMoreBtn) showMoreBtn.classList.add('hidden')
      if (showLessBtn) showLessBtn.classList.remove('hidden')
    }
  }

  showLess(targetClass, tableId, clickedButton) {
    // 指定されたクラスの行を非表示
    const hiddenRows = document.querySelectorAll(`.${targetClass}`)
    hiddenRows.forEach(row => {
      row.classList.add('hidden')
    })

    // ボタンの表示切り替え
    const container = clickedButton.closest('.card-body, .table-container')
    if (container) {
      const showMoreBtn = container.querySelector('[data-show-more]')
      const showLessBtn = container.querySelector('[data-show-less]')

      if (showMoreBtn) showMoreBtn.classList.remove('hidden')
      if (showLessBtn) showLessBtn.classList.add('hidden')
    }

    // テーブルの先頭にスクロール
    if (tableId) {
      const table = document.getElementById(tableId)
      if (table) {
        table.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}

// 自動初期化
new ShowMoreHandler()
